
export const environment = {
  production: false,
  serverAddress: 'https://seebad.test.novasol.com:443/api/v1/',
  username: 'novasol',
};
